import { useLocation } from 'react-router-dom';

/**
 * Patterns for routes where chatbot should be hidden (embedded widgets).
 */
const EXCLUDED_PATTERNS = [
  /^\/public\//, // All public widget routes
  /^\/schedule\//, // Public schedule pages
  /^\/class-essentials\/view\//, // Parent checklist view (public)
];

/**
 * Check if chatbot should be shown on current route.
 * @returns boolean true if chatbot should be displayed
 */
export const useIsChatbotAllowed = (): boolean => {
  const location = useLocation();
  const { pathname } = location;

  // Check if current path matches any excluded pattern
  const isExcluded = EXCLUDED_PATTERNS.some(pattern => pattern.test(pathname));

  // Check if page is embedded in an iframe
  const isIframe = typeof window !== 'undefined' && window.self !== window.top;

  // Also check for embed query parameter
  const isEmbedParam = new URLSearchParams(location.search).has('embed');

  // Chatbot is allowed only if NOT excluded AND NOT in iframe AND NOT embed param
  return !isExcluded && !isIframe && !isEmbedParam;
};
